import { render, staticRenderFns } from "./ProductRequests.vue?vue&type=template&id=dbd803b8&scoped=true&"
import script from "./ProductRequests.vue?vue&type=script&lang=js&"
export * from "./ProductRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd803b8",
  null
  
)

export default component.exports